module.exports = ":root{--lui-tabbar-border-radius:2px;--lui-tabbar-selected-height:0;--lui-tabbar-selected-left:0;--lui-tabbar-selected-top:0;--lui-tabbar-selected-bottom:calc(var(--lui-padding) / 2);--lui-tabbar-selected-width:0;--lui-tabbar-marker-thickness:2px}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-index/theme/lui-index.global.scss
// module id = 226
// module chunks = 0 1 16